import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import Header from '../../templates/TransparentHeader/index';
import Layout from '../../templates/Layout/layout';
import HeroSection from './sections/hero-section';
import Footer from '../../templates/Footer/index';
import Logo from '../../../resources/images/logo-wordmark-black.png'
import TrackUtms from '../../../helpers/utmTracking';
import TileSection from './sections/tile-section';
import Scroll from './sections/horizontal-scroll';
import PillarsSection from './sections/pillars-section';
import PerksSection from './sections/perks-section';

const HeaderProperties = ({ image }) => {
    const imagePath= image.childImageSharp.gatsbyImageData.images.fallback.src;

    return (
        <Helmet>
            <title>Work With Us! Motivosity Careers</title>

            <meta
                name="description"
                content="Life at work should be just as meaningful, satisfying, and enjoyable as life off the clock. We want to work with people that feel the same way!"
            />
            <meta
                property="og:url"
                content="https://www.motivosity.com/careers/"
            />
            <meta property="fb:app_id" content="1448220805478189" />
            <meta
                property="og:image"
                content={ imagePath ? "https://www.motivosity.com" + imagePath : "https://www.motivosity.com" + Logo}
            />
            
            <meta property="og:image:alt" content="Preview image for the Careers page" />
            <meta
                property="og:title"
                content="Work With Us! Motivosity Careers"
            />
            <meta
                property="og:description"
                content="Life at work should be just as meaningful, satisfying, and enjoyable as life off the clock. We want to work with people that feel the same way!"

            />
            <meta name="format-detection" content="telephone=no" />

            <link rel="canonical" href={"https://www.motivosity.com/careers/"} />
        </Helmet>
    );
};

const CareersTemplate = ({ data }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    },[])
     
    return (
        <React.Fragment>
            <Header />
             <HeroSection
                data={data} 
                title={data.heroSectionTitle}
                paragraph={data.heroSectionDescription}
                heroImage={data.heroSectionImage}
            />
            <PillarsSection />
            <Scroll />
            <PerksSection />

            <TileSection />
            <Footer />
        </React.Fragment>
    );
};

const Careers = ({ data, location }) => {
    useEffect(() => {
        TrackUtms();
    },[])

    const { frontmatter: pageData } = data.markdownRemark;

    return (
        <Layout>
            <HeaderProperties
                image={pageData.heroSectionImage}
            />
            <CareersTemplate data={pageData} />
        </Layout>
    );
};

export default Careers;

export const CareersQuery = graphql`
    query Careers($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug} }) {
            html
            frontmatter {
                pageName
                heroSectionImage {
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: NONE
                            quality: 100
                        )
                    }
                } 
            }
        }
    }
`;
